// import { IconWebhook } from '@tabler/icons-react'
// import React, { ReactElement } from 'react'

// import { AiOutlineWhatsApp } from 'react-icons/ai'
// import { GiSatelliteCommunication } from 'react-icons/gi'
// import {
//   MdAttachEmail,
//   MdEmojiPeople,
//   MdOutlineAccountTree,
//   MdOutlinePayments,
// } from 'react-icons/md'
// import { RiHomeGearFill } from 'react-icons/ri'
// import { TiContacts, TiDocument } from 'react-icons/ti'
// import { HiTemplate } from 'react-icons/hi'

// import { GrActions } from 'react-icons/gr'
// import { FaSms, FaTelegram } from 'react-icons/fa'
// import { FcWorkflow } from 'react-icons/fc'
// import {
//   Creditor as CreditorIconPath,
//   User as UserIconPath,
//   Attorney as AttorneyIconPath,
// } from '@bitechsystems/bticons'
// import { ImageIcon } from './Tools'
// import { FiServer, FiType } from 'react-icons/fi'
// import TestSelectBrowse from './TestComponent'
// import TestComponent from './TestComponent'
// import { GoLog } from 'react-icons/go'

// ////////////////////////////Imports///////////////////////////
// const LoginPage = React.lazy(() => import('../components/login/LoginPage'))
// const LogoutPage = React.lazy(() => import('../components/login/LogoutPage'))

// const LandingPageRoute = React.lazy(() =>
//   import('../components/landing/LandingPage')
// )

// const GenerateAction = React.lazy(() =>
//   import('../components/communications/ProcessAction/ProcessAction')
// )

// const EmailIncoming = React.lazy(() =>
//   import('../components/emailheader/EmailIncoming')
// )

// const SocialCommsPage = React.lazy(() =>
//   import('../components/socialcomms/SocialCommsPage')
// )

// const IntfacePage = React.lazy(() =>
//   import('../components/intface/IntfaceWindow')
// )

// const DocVault = React.lazy(() =>
//   import('../components/documentvault/DocVault')
// )

// const Clients = React.lazy(() => import('../components/client/Clients'))

// const ContactPersonRec = React.lazy(() =>
//   import('../components/contactperson/ContactPersonRecipients')
// )

// const CommAccountPage = React.lazy(() =>
//   import('../components/commaccount/CommAccount')
// )

// const WorkFlowSetup = React.lazy(() =>
//   import('../components/workflow/WorkFlowSetup/WorkFlowSetup')
// )

// const HyphenPaymentPlan = React.lazy(() =>
//   import('../components/paymentplan/HyphenPaymentPlan')
// )
// const UpdateAttachment = React.lazy(() =>
//   import('../components/commattachments/form/components/UpdateAttachment')
// )

// const DocumentTypes = React.lazy(() =>
//   import('../components/documenttype/DocumentTypes')
// )
// const EventLog = React.lazy(() => import('../components/eventlog/EventLog'))

// const ClientMandates = React.lazy(() =>
//   import('../components/clientmandate/ClientMandates')
// )

// const IntfaceProviders = React.lazy(() =>
//   import('../components/intface_provider/Main')
// )
// //

// ////////////////////////////Imports///////////////////////////

// /**
//  * Standard Interface for Navigation Components.
//  */
// export interface NavLinks {
//   component?: ReactElement
//   href?: string
//   icon?: ReactElement
//   id: string
//   inactive?: boolean
//   menu?: ReactElement
//   navigate?: string
//   onClick?: (event: any) => void
//   parent?: string
//   signalName?: string
//   skip?: boolean
//   title: string
//   tooltip?: string
// }
// export type NavLinksArray = Array<NavLinks>

// export const AppModules: NavLinksArray = [
//   {
//     component: <LoginPage />,
//     id: 'login',
//     navigate: '/login',
//     title: 'Login',
//     skip: true,
//   },
//   {
//     component: <LogoutPage />,
//     id: 'logout',
//     navigate: '/logout',
//     title: 'Logout',
//     skip: true,
//   },
//   {
//     component: <LandingPageRoute />,
//     icon: <RiHomeGearFill size={24} />,
//     id: 'home',
//     navigate: '/',
//     signalName: 'go-home',
//     title: 'Home',
//   },
//   {
//     component: <Clients />,
//     id: 'clients',
//     title: 'Clients',
//     icon: <MdEmojiPeople size={24} />,
//     navigate: '/clients',
//     signalName: 'go-client',
//   },
//   {
//     icon: <GiSatelliteCommunication size={24} />,
//     id: 'communication',
//     title: 'Communication',
//   },
//   {
//     component: <EmailIncoming />,
//     icon: <MdAttachEmail size={24} />,
//     id: 'emailincoming',
//     navigate: '/comms/emailincoming',
//     parent: 'communication',
//     signalName: 'go-email',
//     title: 'Email',
//   },
//   {
//     component: <GenerateAction name='Generate Action' section='comms' />,
//     icon: <GrActions size={24} />,
//     id: 'generateaction',
//     navigate: '/comms/generateaction?request=insert',
//     parent: 'communication',
//     signalName: 'go-generateaction',
//     title: 'New Action',
//   },
//   {
//     component: <SocialCommsPage entity='sms' />,
//     id: 'sms',
//     title: 'SMS',
//     parent: 'communication',
//     icon: <FaSms size={24} />,
//     navigate: '/comms/sms',
//     signalName: 'go-smsl',
//   },
//   {
//     component: <SocialCommsPage entity='telegram' />,
//     id: 'telegram',
//     title: 'Telegram',
//     parent: 'communication',
//     icon: <FaTelegram size={24} />,
//     navigate: '/comms/telegram',
//     signalName: 'go-telegram',
//   },
//   {
//     component: <SocialCommsPage entity='whatsapp' />,
//     id: 'whatsapp',
//     title: 'WhatsApp',
//     parent: 'communication',
//     icon: <AiOutlineWhatsApp size={24} />,
//     navigate: '/comms/whatsapp',
//     signalName: 'go-whatsapp',
//   },
//   {
//     component: <DocVault rid_parent={0} tableprefix='' />,
//     id: 'docvault',
//     title: 'Document Vault',
//     icon: <TiDocument size={24} />,
//     navigate: '/docvault',
//     signalName: 'go-docvault',
//   },
//   {
//     id: 'masterdata',
//     title: 'Master Data',
//     icon: <HiTemplate size={24} />,
//   },
//   {
//     component: <CommAccountPage />,
//     id: 'commaccount',
//     title: 'API Accounts',
//     icon: <MdOutlineAccountTree size={24} />,
//     parent: 'masterdata',
//     navigate: '/comms/commaccount',
//     signalName: 'go-commaccount',
//   },
//   {
//     component: <DocVault tableprefix='TBUS' />,
//     id: 'businessvault',
//     title: 'Company  Documents',
//     icon: <MdOutlineAccountTree size={24} />,
//     parent: 'masterdata',
//     navigate: '/docvault?tableprefix=TBUS',
//     signalName: 'go-businessvault',
//   },
//   {
//     component: <></>,
//     id: 'attorney',
//     title: 'Attorney',
//     icon: <ImageIcon src={AttorneyIconPath} alt='Attorneys' />,
//     navigate: '/attorneys',
//     signalName: 'go-attorney',
//     skip: true, //Remove later
//   },
//   {
//     component: <ContactPersonRec recType='email' />,
//     id: 'contactperson',
//     title: 'Contact Persons',
//     icon: <TiContacts size={24} />,
//     parent: 'masterdata',
//     navigate: '/comms/contactperson',
//     signalName: 'go-contactperson',
//   },
//   {
//     component: <></>,
//     id: 'traders',
//     title: 'Creditors',
//     icon: <ImageIcon src={CreditorIconPath} alt='Creditors' />,
//     navigate: '/traders',
//     signalName: 'go-trader',
//     skip: true, //Remove later
//   },
//   {
//     component: <DocumentTypes />,
//     id: 'documenttypes',
//     title: 'Document Types',
//     icon: <FiType size={24} />,
//     parent: 'masterdata',
//     navigate: '/documenttypes',
//     signalName: 'go-documenttypes',
//   },
//   {
//     component: <EventLog />,
//     id: 'eventlog',
//     title: 'Event Log',
//     icon: <GoLog size={24} />,
//     parent: 'masterdata',
//     navigate: '/eventlog',
//     signalName: 'go-eventlog',
//   },
//   {
//     component: <></>,
//     id: 'users',
//     title: 'Users',
//     icon: <ImageIcon src={UserIconPath} alt='User' />,
//     navigate: '/users',
//     signalName: 'go-users',
//     skip: true, //Remove later
//   },
//   {
//     component: <IntfacePage />,
//     id: 'intface_transmission',
//     title: 'Web Transmissions',
//     icon: <IconWebhook size={24} />,
//     navigate: '/intface',
//     signalName: 'go-intface',
//   },
//   {
//     component: <IntfaceProviders />,
//     id: 'intfaceproviders',
//     title: 'Web Service Providers',
//     icon: <FiServer size={24} />,
//     parent: 'masterdata',
//     navigate: '/intfaceprovider',
//     signalName: 'go-intfaceproviders',
//   },
//   {
//     id: 'dev',
//     title: 'Development',
//     icon: <HiTemplate size={24} />,
//   },
//   {
//     component: <HyphenPaymentPlan />,
//     id: 'hyphenpaymentplan',
//     title: 'Hyphen Payment Plan',
//     icon: <MdOutlinePayments size={24} />,
//     parent: 'dev',
//     navigate: '/dev/hyphenpaymentplan',
//     signalName: 'go-hyphenpaymentplan',
//   },
//   {
//     component: <TestComponent />,
//     id: 'testcomponent',
//     title: 'Test Component',
//     icon: <FiType size={24} />,
//     parent: 'dev',
//     navigate: '/dev/testcomponent',
//   },
//   {
//     component: (
//       <WorkFlowSetup securityScope='workflow select' request={'select'} />
//     ),
//     id: 'workflowselect',
//     title: 'WorkFlow Select Tree',
//     icon: <FcWorkflow size={24} />,
//     parent: 'dev',
//     navigate: '/dev/workflowselect',
//     signalName: 'go-workflowselect',
//   },
//   {
//     component: (
//       <WorkFlowSetup securityScope='workflow setup' request={'change'} />
//     ),
//     id: 'workflowsetup',
//     title: 'WorkFlow Setup Tree',
//     icon: <FcWorkflow size={24} />,
//     parent: 'dev',
//     navigate: '/dev/workflowsetuptree',
//     signalName: 'go-workflowsetuptree',
//   },
// ]

// export const baseroute = window.location.pathname.startsWith('/res/dist')
//   ? '/res/dist'
//   : ''

// if (AppModules) {
//   AppModules.forEach((v) => {
//     if (
//       v.navigate &&
//       (v.navigate.startsWith('/') || v.navigate.startsWith('./'))
//     ) {
//       v.navigate = baseroute + v.navigate
//     }
//   })
// }
